import { render, staticRenderFns } from "./add-login-number-inside.vue?vue&type=template&id=06b0f798&"
import script from "./add-login-number-inside.vue?vue&type=script&lang=js&"
export * from "./add-login-number-inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports